var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top", attrs: { id: "c-top" } },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticClass: "info" }, [_vm._v("商品分类")]),
            _c(
              "div",
              { staticClass: "info", staticStyle: { "margin-left": "7px" } },
              [_vm._v("/")]
            ),
            _c(
              "div",
              [
                _c(
                  "el-menu",
                  {
                    staticClass: "el-menu-demo",
                    attrs: {
                      "default-active": _vm.activeIndex,
                      mode: "horizontal",
                    },
                    on: { select: _vm.handleSelect },
                  },
                  _vm._l(_vm.btns, function (item, index) {
                    return _c(
                      "el-menu-item",
                      { key: index, attrs: { index: index.toString() } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              attrs: {
                model: _vm.infoForm,
                rules: _vm.infoRules,
                "label-width": "110px",
              },
            },
            [
              _c("h3", [_vm._v("基础信息")]),
              _c("el-form-item", { attrs: { label: "商品分类" } }, [
                _c(
                  "div",
                  {
                    staticClass: "goods-category-edit",
                    staticStyle: { display: "flex" },
                  },
                  [
                    _c("div", [_vm._v(_vm._s(_vm.categoryArrStr))]),
                    _vm.currentPageStatus == "add"
                      ? _c(
                          "div",
                          {
                            staticClass: "edit-btn",
                            on: { click: _vm.toEditCategory },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-edit",
                              staticStyle: { "padding-right": "4px" },
                            }),
                            _vm._v("编辑 "),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "商品类型", prop: "goodsType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.currentPageStatus !== "add" },
                      model: {
                        value: _vm.infoForm.goodsType,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "goodsType", $$v)
                        },
                        expression: "infoForm.goodsType",
                      },
                    },
                    _vm._l(_vm.goods_types, function (item) {
                      return _c("el-radio", {
                        key: item.dictId,
                        attrs: {
                          value: item.dictId,
                          label: item.dictName,
                          name: item.dictId,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "925px" },
                    attrs: {
                      placeholder: "请输入商品名称",
                      maxlength: "60",
                      "show-word-limit": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.infoForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "name", $$v)
                      },
                      expression: "infoForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "12px",
                    "font-family": "Microsoft YaHei",
                    "font-weight": "400",
                    "line-height": "0px",
                    color: "#909099",
                    "margin-left": "106px",
                    "margin-top": "24px",
                    "margin-bottom": "18px",
                  },
                  attrs: { label: "" },
                },
                [_vm._v(" 示例：商品品牌-商品属性-商品名称-商品重量 ")]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注信息" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    attrs: {
                      placeholder: "请输入备注信息",
                      maxlength: "30",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.infoForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "remark", $$v)
                      },
                      expression: "infoForm.remark",
                    },
                  }),
                ],
                1
              ),
              _vm.currentPageStatus == "edit"
                ? _c(
                    "el-form-item",
                    { staticClass: "goods-no", attrs: { label: "商品编号" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "442px" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.infoForm.goodsNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "goodsNo", $$v)
                          },
                          expression: "infoForm.goodsNo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", {
                staticStyle: {
                  width: "674px",
                  height: "0px",
                  border: "1px dashed #ebebfa",
                  opacity: "1",
                  "margin-bottom": "6px",
                },
              }),
              _c("h4", { staticClass: "title-4" }, [_vm._v("商品属性")]),
              _c(
                "el-button",
                {
                  staticClass: "btns",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.addAttr },
                },
                [_vm._v("新增属性")]
              ),
              _vm._l(_vm.attrList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "attr-list" },
                  [
                    _c("div", { staticClass: "no" }, [
                      _vm._v(_vm._s(+index + 1)),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "item-attr",
                        attrs: { label: "属性名称", "label-width": "90px" },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "250px" },
                          attrs: {
                            placeholder: "请输入属性名称",
                            maxlength: "10",
                            "show-word-limit": "",
                          },
                          model: {
                            value: item.key,
                            callback: function ($$v) {
                              _vm.$set(item, "key", $$v)
                            },
                            expression: "item.key",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "item-attr",
                        attrs: { label: "属性参数", "label-width": "90px" },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "350px" },
                          attrs: {
                            placeholder: "请输入属性参数",
                            maxlength: "20",
                            "show-word-limit": "",
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", icon: "el-icon-delete" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteAttr(index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ],
                  1
                )
              }),
              _c("div", { staticStyle: { height: "10px" } }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content image-text-form", attrs: { id: "c-image" } },
        [
          _c("h3", [_vm._v("图文信息")]),
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品图片(0/10)" } },
                [
                  _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("商品图片(" + _vm._s(_vm.fileList.length) + "/10)"),
                  ]),
                  _c("upload-picture", {
                    attrs: { limit: 10, list: _vm.fileList },
                    on: { changeImage: _vm.changeImage },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "" } }, [
                _c("div", { staticClass: "tips" }, [
                  _vm._v(
                    " 图片尺寸：建议上传750px*750px，每张上传大小不得超过2M，支持jpg、png、gif格式 "
                  ),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "商品详情" } }, [
                _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _vm._v(
                    "商品详情 (" + _vm._s(_vm.detailList.length) + "/50) "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "detail" },
                  [
                    _c("upload-picture", {
                      attrs: {
                        limit: 50,
                        list: _vm.detailList,
                        photoType: "detail",
                        fit: "contain",
                      },
                      on: { changeDetailImage: _vm.changeDetailImage },
                    }),
                    _c("div", { staticClass: "tips" }, [
                      _vm._v(
                        " 图片尺寸：建议每张上传大小不得超过2M，支持jpg、png、gif格式 "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "bottom quill",
                    staticStyle: { display: "none" },
                  },
                  [
                    _c("el-upload", {
                      ref: "uploadicon",
                      staticClass: "centerImg",
                      attrs: {
                        action: " ",
                        "list-type": "picture-card",
                        "auto-upload": false,
                        "on-change": _vm.handleAvatarChangeIcon,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content", attrs: { id: "sku-content" } }, [
        _vm._m(0),
        _c("div", { staticClass: "sku-box" }, [
          _vm._m(1),
          _c("div", { staticClass: "sku-content-box" }, [
            _c(
              "div",
              { staticClass: "goods-sale" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "请选择",
                      multiple: "",
                      "collapse-tags": "",
                      "multiple-limit": 3,
                    },
                    on: { change: _vm.onChangeGoodsSaleDataListValue },
                    model: {
                      value: _vm.goodsSaleDataListValue,
                      callback: function ($$v) {
                        _vm.goodsSaleDataListValue = $$v
                      },
                      expression: "goodsSaleDataListValue",
                    },
                  },
                  _vm._l(_vm.skuFormConfig.sourceAttribute, function (item) {
                    return _c("el-option", {
                      key: item.name,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
                _vm.skuFormConfig.attribute.length < 3
                  ? [
                      !_vm.inputVisible
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btns",
                              attrs: {
                                type: "primary",
                                disabled:
                                  _vm.skuFormConfig.attribute.length > 2,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showInput()
                                },
                              },
                            },
                            [_vm._v("添加规格")]
                          )
                        : _vm._e(),
                      _vm.inputVisible
                        ? _c(
                            "el-button",
                            {
                              staticClass: "btns",
                              attrs: {
                                type: "primary",
                                disabled:
                                  _vm.skuFormConfig.attribute.length > 2,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addSpecName()
                                },
                              },
                            },
                            [_vm._v("确认添加")]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "choose-attribute" },
                  [
                    _vm._l(
                      _vm.skuFormConfig.attribute,
                      function (k, fatherIndex) {
                        return [
                          _c(
                            "h5",
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "+ 自定义规格名称",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.changeInput()
                                  },
                                  blur: function ($event) {
                                    return _vm.changeAttributeTitle(
                                      k.name,
                                      fatherIndex
                                    )
                                  },
                                  focus: function ($event) {
                                    return _vm.changeAttributeTitleFocus(
                                      k.name,
                                      fatherIndex
                                    )
                                  },
                                },
                                model: {
                                  value: k.name,
                                  callback: function ($$v) {
                                    _vm.$set(k, "name", $$v)
                                  },
                                  expression: "k.name",
                                },
                              }),
                              _vm.currentPageStatus === "add"
                                ? _c("i", {
                                    staticClass: "el-icon-circle-close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDeleteContent(
                                          fatherIndex,
                                          _vm.childrenIndex,
                                          "father"
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _c("hr"),
                              _c("span", [_vm._v("规格值")]),
                              _c("span", [
                                _vm._v(
                                  "（已选 " + _vm._s(k.item.length) + "）"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "choose-attribute-list" },
                            [
                              _vm._l(k.item, function (tag, childrenIndex) {
                                return [
                                  _vm.skuFormConfig.attribute[fatherIndex]
                                    .itemList[childrenIndex]
                                    ? [
                                        _vm.skuFormConfig.attribute[fatherIndex]
                                          .itemList[childrenIndex].content
                                          ? _c("el-input", {
                                              key: childrenIndex,
                                              attrs: { size: "small" },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.changeInput()
                                                },
                                                change: function ($event) {
                                                  return _vm.onChangeContent(
                                                    fatherIndex,
                                                    childrenIndex
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.skuFormConfig.attribute[
                                                    fatherIndex
                                                  ].itemList[childrenIndex]
                                                    .content,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.skuFormConfig.attribute[
                                                      fatherIndex
                                                    ].itemList[childrenIndex],
                                                    "content",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "skuFormConfig.attribute[fatherIndex].itemList[\n                      childrenIndex\n                    ].content\n                      ",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.currentPageStatus === "add"
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-circle-close",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDeleteContent(
                                                    fatherIndex,
                                                    childrenIndex
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                ]
                              }),
                              _c(
                                "el-input",
                                {
                                  ref: "saveTagInput",
                                  refInFor: true,
                                  staticClass: "input-new-tag",
                                  attrs: {
                                    size: "small",
                                    placeholder: "+ 自定义规格值",
                                  },
                                  on: {
                                    blur: function ($event) {
                                      return _vm.handleInputConfirm(fatherIndex)
                                    },
                                    focus: function ($event) {
                                      return _vm.onFocus(fatherIndex)
                                    },
                                    input: function ($event) {
                                      return _vm.changeInput()
                                    },
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.handleInputConfirm(fatherIndex)
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.skuFormConfig.inputValueArrTemp[
                                        fatherIndex
                                      ],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.skuFormConfig.inputValueArrTemp,
                                        fatherIndex,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "skuFormConfig.inputValueArrTemp[fatherIndex]",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-check",
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleInputConfirm(
                                          fatherIndex
                                        )
                                      },
                                    },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ]
                      }
                    ),
                    _vm.skuFormConfig.attribute.length < 3
                      ? [
                          _vm.inputVisible
                            ? _c(
                                "h5",
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "+ 自定义规格名称",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeInput()
                                      },
                                    },
                                    model: {
                                      value: _vm.specNameTemp.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.specNameTemp, "name", $$v)
                                      },
                                      expression: "specNameTemp.name",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.inputVisible
                            ? _c(
                                "div",
                                { staticClass: "choose-attribute-list" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "+ 自定义规格值",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeInput()
                                      },
                                    },
                                    model: {
                                      value: _vm.specNameTemp.item,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.specNameTemp, "item", $$v)
                                      },
                                      expression: "specNameTemp.item",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "goods-sale-list" },
              [
                _vm.skuFormConfig.attribute.length !== 0
                  ? _c("SkuForm", {
                      ref: "skuForm",
                      attrs: {
                        "source-attribute": _vm.skuFormConfig.sourceAttribute,
                        attribute: _vm.skuFormConfig.attribute,
                        sku: _vm.skuFormConfig.sku,
                        disabled: _vm.skuFormConfig.showForm,
                        structure: _vm.skuFormConfig.structure,
                      },
                      on: {
                        "update:attribute": function ($event) {
                          return _vm.$set(
                            _vm.skuFormConfig,
                            "attribute",
                            $event
                          )
                        },
                        "update:sku": function ($event) {
                          return _vm.$set(_vm.skuFormConfig, "sku", $event)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "skuNo",
                            fn: function (slotSkuNo) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      slotSkuNo.row.skuNo
                                        ? slotSkuNo.row.skuNo
                                        : "- -"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "image",
                            fn: function (slotImg) {
                              return [
                                _c("mall-picture", {
                                  staticStyle: { "margin-left": "4px" },
                                  attrs: { imageUrl: slotImg.row.image },
                                  on: {
                                    getUrl: function ($event) {
                                      return _vm.getImage($event, slotImg)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "status",
                            fn: function (slotProps) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": "1",
                                    "inactive-value": "0",
                                  },
                                  model: {
                                    value: slotProps.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(slotProps.row, "status", $$v)
                                    },
                                    expression: "slotProps.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1050898385
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "content page-component",
          attrs: { id: "page-component" },
        },
        [
          _c("h3", [_vm._v("页面组件")]),
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品标签" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleCheckedCitiesChange },
                      model: {
                        value: _vm.infoForm.goodsLabels,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "goodsLabels", $$v)
                        },
                        expression: "infoForm.goodsLabels",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1" } }, [
                        _c("div", { staticStyle: { "margin-top": "10px" } }, [
                          _c("img", {
                            staticStyle: { width: "42px", height: "20px" },
                            attrs: {
                              src: require("@/assets/icon_jingpin.png"),
                            },
                          }),
                        ]),
                      ]),
                      _c("el-checkbox", { attrs: { label: "2" } }, [
                        _c("div", { staticStyle: { "margin-top": "10px" } }, [
                          _c("img", {
                            staticStyle: { width: "42px", height: "20px" },
                            attrs: { src: require("@/assets/icon_remai.png") },
                          }),
                        ]),
                      ]),
                      _c("el-checkbox", { attrs: { label: "3" } }, [
                        _c("div", { staticStyle: { "margin-top": "10px" } }, [
                          _c("img", {
                            staticStyle: { width: "42px", height: "20px" },
                            attrs: { src: require("@/assets/icon_new.png") },
                          }),
                        ]),
                      ]),
                      _c("el-checkbox", { attrs: { label: "4" } }, [
                        _c("div", { staticStyle: { "margin-top": "10px" } }, [
                          _c("img", {
                            staticStyle: { width: "42px", height: "20px" },
                            attrs: { src: require("@/assets/icon_pinzhi.png") },
                          }),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "按钮文案" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 0 },
                      model: {
                        value: _vm.infoForm.buttonShow,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "buttonShow", $$v)
                        },
                        expression: "infoForm.buttonShow",
                      },
                    },
                    [_vm._v("不显示")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      model: {
                        value: _vm.infoForm.buttonShow,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "buttonShow", $$v)
                        },
                        expression: "infoForm.buttonShow",
                      },
                    },
                    [_vm._v("显示")]
                  ),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.infoForm.buttonShow !== 0,
                        expression: "infoForm.buttonShow !== 0",
                      },
                    ],
                    staticStyle: { width: "340px" },
                    attrs: {
                      placeholder: "请输入按钮文案",
                      maxlength: "16",
                      "show-word-limit": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.infoForm.buttonName,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "buttonName", $$v)
                      },
                      expression: "infoForm.buttonName",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "tips",
                      staticStyle: { margin: "2px 0 0 0" },
                    },
                    [
                      _vm._v(
                        "选择展示，按钮将默认展示在商品详情页中（商品详情之上）"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "跑马灯样式" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-top": "14px" } },
                  [
                    _c(
                      "el-radio",
                      {
                        staticStyle: { display: "flex" },
                        attrs: { label: "0" },
                        model: {
                          value: _vm.infoForm.displayType,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "displayType", $$v)
                          },
                          expression: "infoForm.displayType",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("div", [_vm._v("淡入淡出浮层跑马灯")]),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-class": "atooltipP",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "atooltipP-title" },
                                      [_vm._v("淡入淡出浮层跑马灯")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "atooltipP-title1" },
                                      [_vm._v("显示在主图左上角")]
                                    ),
                                    _c("img", {
                                      staticStyle: {
                                        width: "208px",
                                        height: "88px",
                                        "margin-top": "20px",
                                        "margin-left": "16px",
                                      },
                                      attrs: {
                                        src: require("@/assets/img_fuceng.png"),
                                      },
                                    }),
                                  ]
                                ),
                                _c("img", {
                                  staticStyle: {
                                    width: "18px",
                                    height: "18px",
                                    "margin-top": "-2px",
                                    "margin-left": "4px",
                                  },
                                  attrs: {
                                    src: require("@/assets/icon_qipao.png"),
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-radio",
                      {
                        staticStyle: { display: "flex" },
                        attrs: { label: "1" },
                        model: {
                          value: _vm.infoForm.displayType,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "displayType", $$v)
                          },
                          expression: "infoForm.displayType",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("div", [_vm._v("主图下方跑马灯")]),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-class": "atooltipP",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "atooltipP-title" },
                                      [_vm._v("主图下方跑马灯")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "atooltipP-title1" },
                                      [_vm._v("显示在主图下方")]
                                    ),
                                    _c("img", {
                                      staticStyle: {
                                        width: "320px",
                                        height: "144px",
                                        "margin-top": "20px",
                                        "margin-left": "16px",
                                      },
                                      attrs: {
                                        src: require("@/assets/img_zhutu.png"),
                                      },
                                    }),
                                  ]
                                ),
                                _c("img", {
                                  staticStyle: {
                                    width: "18px",
                                    height: "18px",
                                    "margin-top": "-2px",
                                    "margin-left": "4px",
                                  },
                                  attrs: {
                                    src: require("@/assets/icon_qipao.png"),
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.infoForm.displayType == "1",
                                    expression: "infoForm.displayType == '1'",
                                  },
                                ],
                                staticClass: "title-name",
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "340px" },
                                  attrs: {
                                    placeholder: "请输入文案",
                                    maxlength: "16",
                                    "show-word-limit": "",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.infoForm.runWords,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.infoForm, "runWords", $$v)
                                    },
                                    expression: "infoForm.runWords",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-form-item", { attrs: { label: "服务承诺" } }, [
                _c(
                  "div",
                  { staticClass: "serves" },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        on: { change: _vm.handleCheckedPromisedsChange },
                        model: {
                          value: _vm.infoForm.acceptance,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "acceptance", $$v)
                          },
                          expression: "infoForm.acceptance",
                        },
                      },
                      _vm._l(_vm.promiseds, function (item) {
                        return _c(
                          "el-checkbox",
                          {
                            key: item.id,
                            attrs: { label: item.id, disabled: item.disabled },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "line-height": "20px" } },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      placement: "top",
                                      content: item.message,
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "18px",
                                        height: "18px",
                                        "margin-left": "4px",
                                      },
                                      attrs: {
                                        src: require("@/assets/icon_qipao.png"),
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content bottom-but" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function ($event) {
                  return _vm.back()
                },
              },
            },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.verificationData } },
            [_vm._v("提交上架")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
            "custom-class":
              _vm.dialog.type === "modifyState" ? "modify-state" : "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "modifyState"
            ? [
                _c("modify-state", {
                  attrs: { dialogInfo: _vm.dialog, list: _vm.giftListByGoodId },
                }),
                _c(
                  "div",
                  {
                    staticClass: "header-title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "el-icon-warning" }),
                    ]),
                    _c("label", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.dialog.title)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c("el-button", { on: { click: _vm.centerModifyState } }, [
                      _vm._v("取 消"),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.submitModifyState },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加标签",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "loglabelbox" }, [
            _c(
              "div",
              { staticClass: "loglabeltopbox" },
              _vm._l(_vm.tagList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: "dd" + item.id,
                    staticClass: "labelitem",
                    class: [item.select ? "selected" : "notselected"],
                    style: { cursor: item.select ? "not-allowed" : "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.selectTagFn(index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.tagName) + " ")]
                )
              }),
              0
            ),
            _c("div", { staticClass: "circlebox" }, [
              _vm._v(" 已选 "),
              _c("div", { staticClass: "circle" }, [
                _vm._v(" " + _vm._s(_vm.seletedTag.length) + " "),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "loglabeltopbox",
                staticStyle: { border: "none" },
              },
              _vm._l(_vm.seletedTag, function (item, index) {
                return _c(
                  "div",
                  { key: "dd" + item.id, staticClass: "labelitem labelitemc" },
                  [
                    _vm._v(" " + _vm._s(item.tagName) + " "),
                    _c("i", {
                      staticClass: "el-icon-circle-close labelicon",
                      on: {
                        click: function ($event) {
                          return _vm.deleteTag(index)
                        },
                      },
                    }),
                  ]
                )
              }),
              0
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定SKU",
            visible: _vm.dialogSkuVisible,
            "append-to-body": "",
            width: "32%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSkuVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-left": "30px" } },
            [
              _vm._v(" SKU编码 "),
              _c("el-input", {
                staticStyle: { width: "400px", "margin-left": "15px" },
                attrs: { placeholder: "请输入所需绑定的SKU" },
                model: {
                  value: _vm.bindingSkuNo,
                  callback: function ($$v) {
                    _vm.bindingSkuNo = $$v
                  },
                  expression: "bindingSkuNo",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: {
                "margin-left": "106px",
                color: "#f33f3f",
                "font-size": "12px",
              },
            },
            [_vm._v("请留意新旧商品规格是否一致")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogSkuVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.bindSku } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑",
            visible: _vm.dialogCategory,
            "append-to-body": "",
            width: "32%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCategory = $event
            },
          },
        },
        [
          _c("categoryDialog", {
            attrs: { categoryIds: _vm.cIds },
            on: { changeC: _vm.changeC },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            "append-to-body": true,
            "close-on-click-modal": false,
            visible: _vm.dialogGoods,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogGoods = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "500px", "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c("el-input", {
                    staticStyle: { width: "224px", "margin-right": "20px" },
                    attrs: {
                      placeholder: "请输入商品名称/商品编号",
                      size: "small",
                    },
                    model: {
                      value: _vm.goodsName,
                      callback: function ($$v) {
                        _vm.goodsName = $$v
                      },
                      expression: "goodsName",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchDataG("search")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    data: _vm.goodsList,
                    "show-header": false,
                    border: "",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "60" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("img", {
                                staticStyle: {
                                  width: "72px",
                                  height: "56px",
                                  "margin-right": "12px",
                                },
                                attrs: { src: scope.row.image, alt: "" },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    height: "56px",
                                    display: "flex",
                                    "flex-direction": "column",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#333333" } },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  ),
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#999999" } },
                                    [
                                      _vm._v(
                                        " 商品编号：" +
                                          _vm._s(scope.row.goodsNo) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "align-items": "center",
                    height: "42px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pageNo,
                      "page-sizes": [5, 10, 20, 30],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.totalNum,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "end",
                "margin-top": "24px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "info-q",
                  on: {
                    click: function ($event) {
                      _vm.dialogGoods = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "div",
                { staticClass: "info-s", on: { click: _vm.selectData } },
                [_vm._v("确定")]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "flex" } }, [
      _c("h3", [_vm._v("价格库存")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sku-title" }, [
      _c("i", [_vm._v("*")]),
      _c("span", [_vm._v("商品规格")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }